import React, { FC } from 'react'

interface IProps {
  page: number
  totalPages: number
  onChange: (page: number) => void
}

export const Pagination: FC<IProps> = ({ page, totalPages, onChange }) => {
  const pages: (number | '...')[] = Array.from({ length: totalPages }, (_, i) => i + 1)
    .filter((p) => p === 1 || p === totalPages || Math.abs(p - page) <= 1)
    .reduce<(number | '...')[]>((acc, p, i, arr) => {
      if (i > 0 && (p as number) - (arr[i - 1] as number) > 1) acc.push('...')
      acc.push(p)
      return acc
    }, [])

  const btnBase: React.CSSProperties = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    width: 30,
    height: 30,
    borderRadius: '8px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    color: '#374151',
    padding: 0,
  }

  return (
    <div className='d-flex align-items-center justify-content-center gap-1'>
      <button
        type='button'
        disabled={page === 1}
        style={{ ...btnBase, color: page === 1 ? '#d1d5db' : '#374151' }}
        onClick={() => onChange(page - 1)}
      >
        <i className='bi bi-chevron-left' style={{ fontSize: 13 }} />
      </button>

      {pages.map((p, i) =>
        p === '...' ? (
          <span
            key={`e-${i}`}
            style={{ width: 36, textAlign: 'center', fontSize: 14, color: '#9ca3af' }}
          >
            ...
          </span>
        ) : (
          <button
            key={p}
            type='button'
            style={{
              ...btnBase,
              background: page === p ? '#007BC3' : 'none',
              color: page === p ? 'white' : '#374151',
              fontWeight: page === p ? 600 : 400,
            }}
            onClick={() => onChange(p as number)}
          >
            {p}
          </button>
        )
      )}

      <button
        type='button'
        disabled={page === totalPages}
        style={{ ...btnBase, color: page === totalPages ? '#d1d5db' : '#374151' }}
        onClick={() => onChange(page + 1)}
      >
        <i className='bi bi-chevron-right' style={{ fontSize: 13 }} />
      </button>
    </div>
  )
}
